import React from "react";
import { SITE_CONTENT } from "../content";

const WhyHostsChooseSection = () => {
  const { title, subtitle, items } = SITE_CONTENT.pages.homePage.whyHostsChoose;

  return (
    <section className="bg-[#051109] text-white py-24 lg:py-32 relative overflow-hidden" id="why-choose">
      {/* Glow Effects */}
      <div className="absolute top-0 right-1/4 w-96 h-96 bg-[#006B54]/20 rounded-full blur-[130px] pointer-events-none" />
      <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] bg-[#E8A040]/10 rounded-full blur-[150px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10">
        
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full border border-[#E8A040]/30 bg-[#E8A040]/10 text-[#E8A040] text-xs font-bold tracking-[0.25em] uppercase mb-4">
            Host Expectations
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light font-serif text-[#f8f4ee] mb-4">
            {title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-[#E8A040] to-transparent mx-auto mb-6" />
          <p className="text-[#a0aaa2] text-base sm:text-lg font-light leading-relaxed max-w-xl mx-auto">
            {subtitle}
          </p>
        </div>

        {/* 7 Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8">
          {items.map((item, idx) => (
            <div
              key={idx}
              className={`group relative flex flex-col justify-between p-8 rounded-2xl bg-[#0a1f12]/80 backdrop-blur-sm border border-[#1f3a29] hover:bg-[#0e2a19] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_45px_-15px_rgba(232,160,64,0.15)] hover:border-[#E8A040]/50 overflow-hidden ${
                idx === 6 ? "md:col-span-2 lg:col-span-3 xl:col-span-2 bg-gradient-to-br from-[#0a1f12] to-[#123820]" : ""
              }`}
            >
              {/* Large Background Watermark Number */}
              <div className="absolute -right-2 -bottom-4 text-[110px] font-black text-white/[0.03] group-hover:text-[#E8A040]/[0.06] transition-colors select-none pointer-events-none">
                {item.number}
              </div>

              {/* Accent top line */}
              <div className="absolute top-0 left-8 w-12 h-1 bg-gradient-to-r from-[#D4AF37] to-[#E8A040] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              <div className="relative z-10">
                {/* Number Badge */}
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#132d1d] border border-[#20452d] text-[#E8A040] font-bold text-base mb-6 group-hover:scale-110 group-hover:border-[#E8A040]/40 transition-all shadow-inner">
                  {item.number}
                </div>

                <h3 className="text-[#f8f4ee] text-lg font-medium tracking-wide mb-3 group-hover:text-[#F5C070] transition-colors">
                  {item.title}
                </h3>

                <p className="text-[#96a094] text-sm leading-relaxed font-light">
                  {item.description}
                </p>
              </div>

              {idx === 6 && (
                <div className="relative z-10 mt-6 pt-4 border-t border-white/10 flex items-center justify-between text-xs text-[#22c55e] font-medium">
                  <span>NonVeeFoods Quality Standard</span>
                  <span className="text-[#E8A040]">★ Verified Halal</span>
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyHostsChooseSection;

